module.exports = __webpack_public_path__ + "static/media/onhold.83f52ab8.svg";